export default "/images/937528f0848a72271f8cd6c1a3d0c07e.avif";